<div class="wide">
  <p-table
    #table
    (onPage)="onPrimePageChange($event)"
    (onSort)="onPrimeSortChange($event)"
    [customSort]="true"
    [lazy]="true"
    [loading]="isDataLoading()"
    [paginator]="true"
    [paginatorStyleClass]="'customPrimePaginator'"
    [rowsPerPageOptions]="[5, 10, 25]"
    [rows]="tablePage()?.size || 5"
    [tableStyle]="{ 'min-width': '50rem' }"
    [totalRecords]="tablePage()?.totalElements || 0"
    [value]="rows()"
    class="customPrimeTable"
  >
    <ng-template #header>
      <tr>
        <th pSortableColumn="imie">
          <div class="flex items-center gap-2">
            Imię
            <p-sortIcon field="imie" />
          </div>
        </th>
        <th pSortableColumn="nazwisko">
          <div class="flex items-center gap-2">
            Nazwisko
            <p-sortIcon field="nazwisko" />
          </div>
        </th>
        <th pSortableColumn="pesel">
          <div class="flex items-center gap-2">
            PESEL
            <p-sortIcon field="pesel" />
          </div>
        </th>
        <th pSortableColumn="rola">
          <div class="flex items-center gap-2">
            Rola w organizacji
            <p-sortIcon field="rola" />
          </div>
        </th>
        <th alignFrozen="right" pFrozenColumn>Akcje</th>
      </tr>
      <tr>
        <td class="table-filter-cell">
          <input
            (change)="onPrimeFilterChange($event.target, 'firstName')"
            aria-label="Filtruj po imieniu"
            pInputText
            [(ngModel)]="tableFilters.firstName"
          />
        </td>
        <td class="table-filter-cell">
          <input
            (change)="onPrimeFilterChange($event.target, 'lastName')"
            aria-label="Filtruj po nazwisku"
            pInputText
            [(ngModel)]="tableFilters.lastName"
          />
        </td>
        <td class="table-filter-cell">
          <input
            (change)="onPrimeFilterChange($event.target, 'pesel')"
            aria-label="Filtruj po PESEL"
            pInputText
            [(ngModel)]="tableFilters.pesel"
          />
        </td>
        <td class="table-filter-cell">
          <p-select
            (onChange)="onPrimeFilterChange($event.value ?? '', 'role')"
            [options]="roleOptions"
            [showClear]="true"
            [(ngModel)]="tableFilters.role"
            appendTo="body"
            ariaLabel="Filtruj po roli"
            class="w-full"
          ></p-select>
        </td>
        <td alignFrozen="right" pFrozenColumn class="table-filter-cell"></td>
      </tr>
    </ng-template>
    <ng-template #body let-row>
      <tr>
        <td>{{ row.imie }}</td>
        <td>{{ row.nazwisko }}</td>
        <td>{{ row.pesel }}</td>
        <td>
          {{
            row.rola | constLabelReader: ROLA_REPREZNTANTA_ORGANIZACJI_LABELS
          }}
        </td>
        <td alignFrozen="right" pFrozenColumn class="h-16 align-middle">
          <div class="flex items-center gap-3">
            @if ((row.zalaczniki?.length ?? 0) > 0) {
              <p-button
                ariaLabel="Pobierz pełnomocnictwo"
                icon="pi pi-download"
                pTooltip="Pobierz pełnomocnictwo"
                tooltipPosition="top"
                [rounded]="true"
                [text]="true"
                (click)="downloadRepresentativePowerOfAttorney(row)"
              />
            }
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template #emptymessage>
      <tr>
        <td colspan="5">Brak danych.</td>
      </tr>
    </ng-template>
  </p-table>
</div>

<div class="narrow">
  <p-card class="mb-4">
    <div class="flex flex-col gap-4">
      <div class="flex flex-col gap-2">
        <label for="relatedPersonFirstNameMobile" class="font-bold">Imię</label>
        <input
          id="relatedPersonFirstNameMobile"
          (input)="onPrimeFilterChangeMobile($event.target, 'firstName')"
          pInputText
          class="w-full"
          [(ngModel)]="tableFilters.firstName"
        />
      </div>
      <div class="flex flex-col gap-2">
        <label for="relatedPersonLastNameMobile" class="font-bold">
          Nazwisko
        </label>
        <input
          id="relatedPersonLastNameMobile"
          (input)="onPrimeFilterChangeMobile($event.target, 'lastName')"
          pInputText
          class="w-full"
          [(ngModel)]="tableFilters.lastName"
        />
      </div>
      <div class="flex flex-col gap-2">
        <label for="relatedPersonPeselMobile" class="font-bold">PESEL</label>
        <input
          id="relatedPersonPeselMobile"
          (input)="onPrimeFilterChangeMobile($event.target, 'pesel')"
          pInputText
          class="w-full"
          [(ngModel)]="tableFilters.pesel"
        />
      </div>
      <div class="flex flex-col gap-2">
        <label for="relatedPersonRoleMobile" class="font-bold">
          Rola w organizacji
        </label>
        <p-select
          inputId="relatedPersonRoleMobile"
          (onChange)="onPrimeFilterChange($event.value ?? '', 'role')"
          [options]="roleOptions"
          [showClear]="true"
          [(ngModel)]="tableFilters.role"
          appendTo="body"
          class="w-full"
        ></p-select>
      </div>
      <div class="flex justify-end">
        <p-button
          type="button"
          label="Wyczyść filtry"
          styleClass="customInfoButton outlined"
          (click)="clearFilters()"
        />
      </div>
    </div>
  </p-card>

  <div class="flex flex-col gap-4">
    @for (row of rows(); track row.idBeneficjenta) {
      <p-card>
        <div class="flex flex-col">
          <app-preview-data-wrapper
            label="Imię"
            [data]="row.imie"
            additionalCssClasses="font-bold"
          ></app-preview-data-wrapper>
          <hr class="limiter" />
          <app-preview-data-wrapper
            label="Nazwisko"
            [data]="row.nazwisko"
            additionalCssClasses="font-bold"
          ></app-preview-data-wrapper>
          <hr class="limiter" />
          <app-preview-data-wrapper
            label="PESEL"
            [data]="row.pesel"
            additionalCssClasses="font-bold"
          ></app-preview-data-wrapper>
          <hr class="limiter" />
          <app-preview-data-wrapper
            label="Rola w organizacji"
            [data]="mapRoleLabel(row.rola)"
            additionalCssClasses="font-bold"
          ></app-preview-data-wrapper>

          <div class="mt-5 flex flex-wrap justify-end gap-2">
            <p-button
              label="Pobierz pełnomocnictwo"
              styleClass="customInfoButton outlined"
              (click)="downloadRepresentativePowerOfAttorney(row)"
            />
          </div>
        </div>
      </p-card>
    } @empty {
      <p-card>
        <span>-</span>
      </p-card>
    }
  </div>

  <div class="mt-4 flex flex-col items-end gap-2">
    <p-paginator
      (onPageChange)="onPrimePageChange($event)"
      [rowsPerPageOptions]="[5, 10, 25]"
      [rows]="tablePage()?.size || 5"
      [totalRecords]="tablePage()?.totalElements || 0"
      pageLinkSize="3"
      class="customPrimePaginator"
    />
    <div class="text-sm">
      Strona {{ (tablePage()?.number || 0) + 1 }} z
      {{ tablePage()?.totalPages || 0 }}
    </div>
  </div>
</div>
